export const groupMatchesByRoundName = (matches) => {
    return PULSE.app.common.arrayHelper.groupBy(
        matches,
        (match) => match.round.name
    );
};
